import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DisplayableItemListComponent } from '../../../../../../shared/components/displayable-content/displayable-item-list/displayable-item-list.component';
import { DigitalTemplateCollectionsViewModel } from '../digital-template-collections-view-model';

@Component({
  selector: 'app-digital-template-collection-list',
  templateUrl:
    '../../../../../../shared/components/displayable-content/displayable-item-list/displayable-item-list.component.html',
  styleUrls: [
    '../../../../../../shared/components/displayable-content/displayable-item-list/displayable-item-list.component.scss',
    './digital-template-collections-list.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DigitalTemplateCollectionsListComponent extends DisplayableItemListComponent {
  constructor(
    digitalProductTemplatesViewModel: DigitalTemplateCollectionsViewModel // Provided by parent component
  ) {
    super(digitalProductTemplatesViewModel);
  }
}
